import { render, staticRenderFns } from "./deanHeaderMobileToggle.vue?vue&type=template&id=2560bc84&scoped=true"
import script from "./deanHeaderMobileToggle.vue?vue&type=script&lang=ts"
export * from "./deanHeaderMobileToggle.vue?vue&type=script&lang=ts"
import style0 from "./deanHeaderMobileToggle.vue?vue&type=style&index=0&id=2560bc84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2560bc84",
  null
  
)

export default component.exports